import React, { useEffect, useState } from 'react';
import { expenseService, ExpenseRecord } from '../../services/expenseService';

const ExpenseTable: React.FC = () => {
  const [rows, setRows] = useState<ExpenseRecord[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await expenseService.list({ limit: 50 });
      setRows(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="bg-white rounded shadow">
      <div className="p-3 font-medium">Recent Expenses</div>
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-50 text-left">
              <th className="p-2">Date</th>
              <th className="p-2">Amount</th>
              <th className="p-2">Currency</th>
              <th className="p-2">Category</th>
              <th className="p-2">Vendor</th>
              <th className="p-2">Fixed</th>
              <th className="p-2">Notes</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} className="border-t">
                <td className="p-2">{r.date?.slice(0,10)}</td>
                <td className="p-2">{r.amount.toFixed(2)}</td>
                <td className="p-2">{r.currency}</td>
                <td className="p-2">{r.category || '-'}</td>
                <td className="p-2">{r.vendor || '-'}</td>
                <td className="p-2">{r.is_fixed ? 'Yes' : 'No'}</td>
                <td className="p-2">{r.notes || '-'}</td>
              </tr>
            ))}
            {!loading && rows.length === 0 && (
              <tr><td className="p-3 text-gray-500" colSpan={7}>No expenses yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="p-3">
        <button className="btn btn-secondary" onClick={load} disabled={loading}>{loading ? 'Loading...' : 'Refresh'}</button>
      </div>
    </div>
  );
};

export default ExpenseTable;
